/* eslint-disable import/no-unresolved */

import { addLocaleData } from 'react-intl';

import DateUtil from 'lib/DateUtil';

import userActions from 'redux/actions/user';

export const types = {
  SET_DEFAULT_CLIENT_LOCALE: 'app/locale/SET_DEFAULT_CLIENT_LOCALE',
  SET_CLIENT_LOCALES: 'app/locale/SET_CLIENT_LOCALES',
  ADD_LOCALE: 'app/locale/ADD_LOCALE',
  SET_CURRENT_LOCALE: 'app/locale/SET_CURRENT_LOCALE',
  LOCALE_LOADED: 'app/locale/LOCALE_LOADED',
};

function setWindowTitle(languageMessages) {
  window.document.title = languageMessages['app.groups.name'];
}

function loadLocale(languageCode) {
  return new Promise((resolve, reject) => {
    switch (languageCode) {
      case 'es':
        import(/* webpackChunkName: "intl-es-react-intl" */ 'react-intl/locale-data/es').then(reactIntlLocaleData => {
          addLocaleData(reactIntlLocaleData.default);
        });
        import(/* webpackChunkName: "intl-es-messages" */ '../../localeFiles/es.json').then(languageMessages => {
          resolve(languageMessages.default);
        });
        import(/* webpackChunkName: "intl-es-moment" */ 'moment/locale/es');
        break;
      case 'fr':
        import(/* webpackChunkName: "intl-fr-react-intl" */ 'react-intl/locale-data/fr').then(reactIntlLocaleData => {
          addLocaleData(reactIntlLocaleData.default);
        });
        import(/* webpackChunkName: "intl-fr-messages" */ '../../localeFiles/fr.json').then(languageMessages => {
          resolve(languageMessages.default);
        });
        import(/* webpackChunkName: "intl-fr-moment" */ 'moment/locale/fr');
        break;
      case 'de':
        import(/* webpackChunkName: "intl-de-react-intl" */ 'react-intl/locale-data/de').then(reactIntlLocaleData => {
          addLocaleData(reactIntlLocaleData.default);
        });
        import(/* webpackChunkName: "intl-de-messages" */ '../../localeFiles/de.json').then(languageMessages => {
          resolve(languageMessages.default);
        });
        import(/* webpackChunkName: "intl-de-moment" */ 'moment/locale/de');
        break;
      case 'pt':
        import(/* webpackChunkName: "intl-pt-react-intl" */ 'react-intl/locale-data/pt').then(reactIntlLocaleData => {
          addLocaleData(reactIntlLocaleData.default);
        });
        import(/* webpackChunkName: "intl-pt-messages" */ '../../localeFiles/pt.json').then(languageMessages => {
          resolve(languageMessages.default);
        });
        import(/* webpackChunkName: "intl-pt-moment" */ 'moment/locale/pt');
        break;
      case 'it':
        import(/* webpackChunkName: "intl-it-react-intl" */ 'react-intl/locale-data/it').then(reactIntlLocaleData => {
          addLocaleData(reactIntlLocaleData.default);
        });
        import(/* webpackChunkName: "intl-it-messages" */ '../../localeFiles/it.json').then(languageMessages => {
          resolve(languageMessages.default);
        });
        import(/* webpackChunkName: "intl-it-moment" */ 'moment/locale/it');
        break;
      case 'en':
      default:
        import(/* webpackChunkName: "intl-en-react-intl" */ 'react-intl/locale-data/en').then(reactIntlLocaleData => {
          addLocaleData(reactIntlLocaleData.default);
        });
        import(/* webpackChunkName: "intl-en-messages" */ '../../localeFiles/en.json').then(languageMessages => {
          resolve(languageMessages.default);
        });
        break;
    }
  });
}

function setCurrentLocale(localeData) {
  return (dispatch) => {
    const languageCode = localeData.language_code;
    loadLocale(languageCode)
    .then((languageMessages) => {
      DateUtil.setLocale(languageCode);
      setWindowTitle(languageMessages);

      dispatch(userActions.setPreferredLanguage(localeData, languageMessages));
    });
  }
}


function addLocale(localeData, preferredLanguageCode) {
  return (dispatch) => {
    const languageCode = localeData.language_code;
    // const preferredLanguageCode = localeData.preferredLanguageCode;
    // const languageMessages = yield call (loadLocale, languageCode);
    loadLocale(languageCode)
    .then((languageMessages) => {
      DateUtil.setLocale(preferredLanguageCode);
      dispatch(localeLoaded(languageCode, languageMessages));
    });
  }
}

function localeLoaded(languageCode, languageMessages) {
  return {
    type: types.LOCALE_LOADED,
    payload: {
      languageCode,
      languageMessages,
    },
  };
}

function setDefaultClientLocale(defaultClientLocale) {
  return {
    type: types.SET_DEFAULT_CLIENT_LOCALE,
    payload: {
      defaultClientLocale,
    },
  };
}

function setClientLocales(clientLocales) {
  return {
    type: types.SET_CLIENT_LOCALES,
    payload: {
      clientLocales,
    },
  };
}

function initializeClientLocales() {
  let languages = window.navigator.languages ? window.navigator.languages : [];
  if (languages.length === 0) {
    languages = window.navigator.language ? [window.navigator.language] : [window.navigator.browserLanguage];
  }

  // default language based on marketing web referrer lang setting
  const knownReferrerDomain = 'backpackhealth.com';
  const referrerOrigin = document.referrer ? new window.URL(document.referrer).origin : '';
  if (referrerOrigin.endsWith(knownReferrerDomain)) {
    const localeRegexp = new RegExp(`(.*${knownReferrerDomain}/)([a-z]{2})/.*`);
    const match = localeRegexp.exec(document.referrer);
    if (match && match.length > 2) {
      languages = [match[2]];
    }
  }

  return setClientLocales(languages);
}

const actions = {
  setCurrentLocale,
  addLocale,
  localeLoaded,
  setDefaultClientLocale,
  initializeClientLocales,
};

export default actions;
